import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useChatbot } from "../../components/ChatbotManager/ChatbotManager";
import { useAppSelector } from "../../store";
import { chatbotPath } from "../util/routeUtils";
import defaultContent from "../../content/common";

/**
 * Hook that handles route-based side effects:
 * - Updates document title
 * - Scrolls to top on route change
 * - Manages chatbot visibility based on route
 */
export const useRoutingEffects = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation(["common"]);
  const { enableChatBot } = useChatbot();
  const showChatbot = useAppSelector((state) => state.boot.configuration.showChatbot);

  document.title = `${t("newSiteTitle", defaultContent["newSiteTitle"])}`;

  useEffect(() => {
    if (!showChatbot) return;
    if (chatbotPath(pathname)) {
      enableChatBot(true);
    } else {
      enableChatBot(false);
    }
  }, [pathname, enableChatBot, showChatbot]);

  // Scroll to top on route change
  useEffect(() => {
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
};
